import { render, staticRenderFns } from "./shared-data-list.html?vue&type=template&id=d0496a00&scoped=true&external"
import script from "./shared-data-list.js?vue&type=script&lang=js&external"
export * from "./shared-data-list.js?vue&type=script&lang=js&external"
import style0 from "./shared-data-list.scss?vue&type=style&index=0&id=d0496a00&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0496a00",
  null
  
)

export default component.exports